module.exports = __webpack_public_path__ + "img/telegram.854a78fa.png";